import { render, staticRenderFns } from "./VideoFilter.vue?vue&type=template&id=4dea6028&scoped=true&"
import script from "./VideoFilter.vue?vue&type=script&lang=js&"
export * from "./VideoFilter.vue?vue&type=script&lang=js&"
import style0 from "./VideoFilter.vue?vue&type=style&index=0&id=4dea6028&prod&lang=scss&"
import style1 from "./VideoFilter.vue?vue&type=style&index=1&id=4dea6028&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea6028",
  null
  
)

export default component.exports